import * as ppWeb from "pp-web"

const { cfg } = ppWeb

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: cfg.poln_web.user_pool_id,
      userPoolClientId: cfg.poln_web.user_pool_client_id,
      identityPoolId: cfg.poln_web.idp_pool_id,
      loginWith: {
        oauth: {
          domain: cfg.poln_web.user_pool_domain,
          scopes: ['openid', 'email', 'profile', 'phone', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [
            cfg.poln_web.redirect_sign_in, 
            'https://qa-a-web.datadyno/deals/creator',
            'https://qa-a-newsfiliate.creatorboost.ai/deals/creator',
            'https://qa-b-newsfiliate.creatorboost.ai/deals/creator',
            'https://qa-newsfiliate.creatorboost.ai/deals/creator',
            'https://prod-a-web.datadyno/deals/creator/deals/creator',
            'https://prod-b-web.datadyno/deals/creator/deals/creator',
            'https://prod-a-newsfiliate.creatorboost.ai/deals/creator',
            'https://prod-b-newsfiliate.creatorboost.ai/deals/creator',
            'https://newsfiliate.creatorboost.ai/deals/creator'
          ],
          redirectSignOut: [
            cfg.poln_web.redirect_sign_out,
            'https://qa-a-web.datadyno/deals/creator',
            'https://qa-a-newsfiliate.creatorboost.ai/deals/creator',
            'https://qa-b-newsfiliate.creatorboost.ai/deals/creator',
            'https://qa-newsfiliate.creatorboost.ai/deals/creator',
            'https://prod-a-web.datadyno/deals/creator',
            'https://prod-b-web.datadyno/deals/creator',
            'https://prod-a-newsfiliate.creatorboost.ai/deals/creator',
            'https://prod-b-newsfiliate.creatorboost.ai/deals/creator',
            'https://newsfiliate.creatorboost.ai/deals/creator'
          ],
          responseType: 'code'
        },
        username: 'true',
        email: 'true',
      },
    }
  },
  Storage: {
    S3: {
      bucket: cfg.poln_web.s3_bucket,
      region: cfg.poln_web.s3_region,
    }
  }
};

export default awsconfig;
